import { FC } from 'react';

import { RoundWinnerOutcomes } from 'shared/constants/shared-enums';
import { getMoveIcon } from 'shared/utils/getMoveIcon';
import { getMoveIconText } from 'shared/utils/getMoveIconText';

interface StreamDesktopHistoryMoveProps {
  round: {
    moveA: number;
    moveB: number;
    winner: RoundWinnerOutcomes;
  };
  show?: boolean;
  forPlayer: 'playerA' | 'playerB';
  totalVisible: number;
  index: number;
}

export const StreamDesktopHistoryMove: FC<StreamDesktopHistoryMoveProps> = ({
  round,
  show,
  forPlayer,
  index,
  totalVisible,
}) => {
  const move = forPlayer === 'playerA' ? round.moveA : round.moveB;

  if (!show || !round.moveA || !round.moveB) return null;

  const isWinner =
    (round.winner === RoundWinnerOutcomes.PlayerA && forPlayer === 'playerA') ||
    (round.winner === RoundWinnerOutcomes.PlayerB && forPlayer === 'playerB');

  const isDraw = round.winner === RoundWinnerOutcomes.Draw;

  const backgroundClass = isDraw
    ? 'border-[#323E96] bg-[#1D213E]'
    : isWinner
      ? 'border-[#FFC000] bg-[#89611C]'
      : 'border-[#E81C34] bg-[#7B3656]';

  const isFaded = index !== totalVisible - 1;

  return (
    <div
      className={`relative flex h-[76px] w-[60px] shrink-0 flex-col items-center justify-center gap-1 self-center rounded-[12px] border border-solid pb-1 pl-[9px] pr-[9px] pt-1 transition-opacity duration-200 ${backgroundClass} ${isFaded ? 'opacity-75' : 'opacity-100'}`}
    >
      {getMoveIcon(move, `h-[32px] w-[36px] ${forPlayer === 'playerA' ? 'scale-x-[-1]' : ''}`)}
      <div className="text-left text-[9px] font-semibold leading-[8px] text-white sm:text-[12px]">
        {getMoveIconText(move)}
      </div>
    </div>
  );
};
